import * as S from './styles';
import type { DocumentationLegendBlocksProps } from './types';

/**
 * The legend's two fixed blocks (FEAT-07 §4.4.3, PAT-18): tickmarks first, then the
 * numbered notes, with Figma's rule between them (41164:71330). The rule is drawn only
 * when both blocks have entries. The order inside each block is the surface's, because
 * the two legends key their entries differently.
 */
export function DocumentationLegendBlocks({ tickmarks, notes }: DocumentationLegendBlocksProps) {
  return (
    <>
      {tickmarks}
      {tickmarks.length > 0 && notes.length > 0 && (
        <S.LegendBlocksDivider role='separator' data-testid='legend-blocks-divider' />
      )}
      {notes}
    </>
  );
}
